import React from "react";

const PlusCircleIcon = ({
  size = 16,
  color = "#BC6B38",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8 0C12.4 0 16 3.6 16 8C16 12.4333 12.4 16 8 16C3.56667 16 0 12.4333 0 8C0 3.6 3.56667 0 8 0ZM11.2 8.8C11.6333 8.8 12 8.46667 12 8C12 7.56667 11.6333 7.2 11.2 7.2H8.8V4.8C8.8 4.36667 8.43333 4 8 4C7.53333 4 7.2 4.36667 7.2 4.8V7.2H4.8C4.33333 7.2 4 7.56667 4 8C4 8.46667 4.33333 8.8 4.8 8.8H7.2V11.2C7.2 11.6667 7.53333 12 8 12C8.43333 12 8.8 11.6667 8.8 11.2V8.8H11.2Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusCircleIcon;